import { render, staticRenderFns } from "./BigPic.vue?vue&type=template&id=20a36de7&scoped=true&"
import script from "./BigPic.vue?vue&type=script&lang=ts&"
export * from "./BigPic.vue?vue&type=script&lang=ts&"
import style0 from "./BigPic.vue?vue&type=style&index=0&id=20a36de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a36de7",
  null
  
)

export default component.exports